<style lang="scss" scoped>
@import '../css/sub.scss';
</style>
<template>
  <div class="urban-asset view-template">
    <urban-header></urban-header>
    <div class="urban-sub">
        <div class="view-contents">
          <div class="column-container">
            <div class="column-row">
                <h3 class="blind">상세조회</h3>
                <div class="visual-tit">
                  <div class="detail-row">
                    <div class="row-box">
                      <span class="tit">분류</span>
                      <span class="desc" v-html="detailKind"></span>
                      <span class="desc" v-if="this.typeEstateCode === '009'">공모가</span>
                      <span class="desc" v-if="this.typeEstateCode === '009'">수익률</span>
                    </div>
                    <div class="row-box">
                      <span class="tit">{{typeDeal}}</span>
                      <span class="desc" v-if="this.typeEstateCode !== '009'" v-html="detilePrice"></span>
                      <span class="desc" v-if="this.typeEstateCode === '007' || this.typeEstateCode === '008'">{{'최초 분양가: '+firstPriceEstate}}</span>
                      <span class="desc" v-if="this.typeEstateCode === '009'">{{offeringAmount+'원'}}</span>
                      <span class="desc" v-if="this.typeEstateCode === '009'">{{offeringPrice+'원'}}</span>
                      <span class="desc" v-if="this.typeEstateCode === '009'">{{returnAmount+'%'}}</span>
                    </div>
                  </div>
                </div>
                <p class="visual-address" v-if="this.typeEstateCode === '009' && (this.startDate || this.endDate)">{{'공모 기간 '+startDate+'~'+endDate}}</p>
                <p class="visual-address" v-html="detailAddress"></p>
                <div class="visual-photo">
                  <div class="photo-represent" v-if="typeof this.AttachedFile[0] === 'undefined'">
                    <img v-img:group src="../img/thumbnail-large.jpg" alt="">
                  </div>
                  <div class="photo-represent" v-else >
                    <img v-img:group :src="$store.state.common.urlpath + this.AttachedFile[0].path" alt="">
                  </div>
                  <div class="photo-list">
                    <div class="photo-item" v-if="typeof this.AttachedFile[1] === 'undefined'">
                      <img v-img:group src="../img/thumbnail-medium.jpg" alt="">
                    </div>
                    <div class="photo-item" v-else>
                      <img v-img:group :src="$store.state.common.urlpath + this.AttachedFile[1].path" alt="">
                    </div>
                    <div class="photo-item" v-if="typeof this.AttachedFile[2] === 'undefined'">
                      <img v-img:group src="../img/thumbnail-medium.jpg" alt="">
                    </div>
                    <div class="photo-item" v-else>
                      <img v-img:group :src="$store.state.common.urlpath + this.AttachedFile[2].path" alt="">
                    </div>
                    <div class="photo-item" v-if="typeof this.AttachedFile[3] === 'undefined'">
                      <img v-img:group src="../img/thumbnail-medium.jpg" alt="">
                    </div>
                    <div class="photo-item" v-else>
                      <img v-img:group :src="$store.state.common.urlpath + this.AttachedFile[3].path" alt="">
                    </div>
                    <div class="photo-item" v-if="typeof this.AttachedFile[4] === 'undefined'">
                      <img v-img:group src="../img/thumbnail-medium.jpg" alt="">
                    </div>
                    <div class="photo-item" v-else>
                      <img v-img:group :src="$store.state.common.urlpath + this.AttachedFile[4].path" alt="">
                    </div>
                  </div>
                </div>
                <!-- 모바일 일때 슬라이드 일단 히든처리 -->
                <div class="visual-slide" style="display:none">
                  <swiper ref="viewSwiper" :options="viewOptions">
                    <swiper-slide>
                        <div class="thumb-img">
                          <img src="../img/main/right-banner-01.jpg" alt="">
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                  </swiper>
                </div>
            </div>
            <div class="column-row">
                <h3 class="column-tit">상세정보</h3>
                <div class="item-num">
                  <strong>매물번호[<span class="num" v-html="itemNumber"></span>]</strong>
                </div>
                <div class="item-desc">
                  <ul class="desc-list">
                    <li class="list-item" v-if="detailListNinth.desc">
                      <span class="tit">- {{detailListNinth.tit}}</span>
                      <span class="desc">{{detailListNinth.desc+' (㎡='+eaEstate_c+')'}}</span>
                    </li>
                    <li class="list-item" v-if="detailListTenth.desc">
                      <span class="tit">- {{detailListTenth.tit}}</span>
                      <span class="desc">{{detailListTenth.desc+' (㎡='+caEstate_c+')'}}</span>
                    </li>
                    <li class="list-item" v-if="detailListFirst.screen">
                      <span class="tit">- {{detailListFirst.tit}}</span>
                      <span class="desc">{{detailListFirst.desc}}</span>
                    </li>
                    <li class="list-item" v-if="detailListSecond.screen">
                      <span class="tit">- {{detailListSecond.tit}}</span>
                      <span class="desc">{{detailListSecond.desc}}</span>
                    </li>
                    <li class="list-item" v-if="detailListThird.screen">
                      <span class="tit">- {{detailListThird.tit}}</span>
                      <span class="desc">{{detailListThird.desc}}</span>
                    </li>
                    <li class="list-item" v-if="detailListFourth.screen">
                      <span class="tit">- {{detailListFourth.tit}}</span>
                      <span class="desc">{{detailListFourth.desc}}</span>
                    </li>
                    <li class="list-item" v-if="detailListFifth.screen">
                      <span class="tit">- {{detailListFifth.tit}}</span>
                      <span class="desc">{{detailListFifth.desc}}</span>
                    </li>
                    <li class="list-item" v-if="detailListSixth.screen">
                      <span class="tit">- {{detailListSixth.tit}}</span>
                      <span class="desc">{{detailListSixth.desc}}</span>
                    </li>
                    <li class="list-item" v-if="detailListSeventh.screen">
                      <span class="tit">- {{detailListSeventh.tit}}</span>
                      <span class="desc">{{detailListSeventh.desc}}</span>
                    </li>
                    <li class="list-item" v-if="detailListEighth.screen">
                      <span class="tit">- {{detailListEighth.tit}}</span>
                      <span class="desc">{{detailListEighth.desc}}</span>
                    </li>
                  </ul>
                </div>
                <div class="other-details">
                    {{descEstate}}
                </div>
            </div>
            <hr class="line">
            <div class="column-row">
              <div class="banner-list">
                <div class="banner first">
                  <a href="http://www.iros.go.kr/PMainJ.jsp" target="_blank">
                  <span class="tit">등기부등본 열람하기</span>
                  <span class="desc">[인터넷등기소]</span>
                  </a>
                </div>
                <div class="banner second">
                  <a href="https://www.gov.kr/portal/main" target="_blank">
                  <span class="tit">건축물대장·토지대장 열람하기</span>
                  <span class="desc">[정부24]</span>
                  </a>
                </div>
                <div class="banner third">
                  <a href="https://disco.re/" target="_blank">
                  <span class="tit">실거래가 확인 사이트</span>
                  <span class="desc">[디스코]</span>
                  </a>
                </div>
                <div class="banner fourth">
                  <a href="http://www.eum.go.kr/web/am/amMain.jsp" target="_blank">
                  <span class="tit">국토교통부 토지이용계획안 확인</span>
                  <span class="desc">[토지이용규제정보서비스 LURIS]</span>
                  </a>
                </div>
                <div class="banner fifth">
                  <a href="http://www.molit.go.kr/portal.do" target="_blank"></a>
                </div>
                <div class="banner sixth">
                </div>
              </div>
            </div>
            <div class="column-row">
              <h3 class="column-tit">위치정보</h3>
              <p class="visual-address map" v-html="detailAddress"></p>
              <div class="view-map-area">
                <div id="map"></div>
              </div>
              <div class="notice-area">
                <p class="notice">허위매물 혹은 사기일 경우 등록이 제한 될 수 있으며,<strong>회원간 직거래이기 때문에 부땡톡은 어떠한 법적절차를 책임지지 않습니다.</strong>꼭 확인하시길 바랍니다.</p>
              </div>
            </div>
          </div>
          <div class="close-area">
            <!--<router-link to="..." class="default-btn">창 닫기</router-link>-->
            <button class="default-btn" @click="prevPage()">창 닫기</button>
          </div>
        </div>
        <div class="favorite-area">
          <button type="button" class="fv-btn" v-if="this.favoriteFlag === true" @click="favoriteToggle()"><b-icon-star-fill></b-icon-star-fill>관심매물 해제
          </button>
          <button type="button" class="fv-btn" v-else @click="favoriteToggle()"><b-icon-star></b-icon-star>관심매물 등록
          </button>
        </div>
          <div class="mobile-inform">
            <div class="mobile-distribution-list">
              <span>직거래</span>
              <span>매물등록인</span>
              <span>{{this.viewEstate.regName}}</span>
              <span>전화번호</span>
              <span>{{this.viewEstate.regTel}}</span>
            </div>
            <button type="button" class="default-btn" @click="recommendOpen()">해당 지역 전문가 보기 <i class="plus-icon"></i></button>
          </div>
        <aside class="view-aside">
          <span class="side-tit">직거래</span>
          <div class="inform">
            <dl>
              <dt class="tit">매물등록인</dt>
              <dd class="desc">{{this.viewEstate.regName}}</dd>
            </dl>
            <button type="button" class="default-btn direct-contact" @click="directContact()">직접 연락하기</button>
          </div>
          <button type="button" class="view-expert" @click="recommendOpen()">해당 지역 전문가 보기 <i class="plus-icon"></i></button>
        </aside>
        <div class="popup-container" v-if="asidePopup">
            <div class="user-inform" v-if="userPopup">
              <dl class="distribution-list">
                <dt>매물등록인</dt>
                <dd>{{this.viewEstate.regName}}</dd>
                <dt>전화번호</dt>
                <dd>{{this.viewEstate.regTel}}</dd>
              </dl>
              <button type="button" @click="popupClose" class="default-btn close-btn">닫기</button>
            </div>
            <div class="recommend-inform" v-if="recommendPopup">
              <div class="recommend-kind" v-if="proRecommend">
                <h3 class="popup-tit">추천 전문가
                  <button type="button" @click="popupClose" class="close">
                    <b-icon-x></b-icon-x>
                  </button>
                </h3>
                <div class="recommend-desc">
                  <ul class="kind-list">
                    <li class="list-item" v-for="(item, index) in this.proTypeArray" :key="index">
                      <button type="button" class="item-btn" @click="kindOpen(item, index)">
                        <i class="icon" :style="{backgroundImage: 'url('+require('../img/main/recommend-list-'+item.proType+'.png')+')'}"></i>
                        <span class="tit">{{item.proTypeNm}}</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="recommend-list" v-if="kindRecommend">
                <button type="button" @click="popupClose" class="close">
                  <b-icon-x></b-icon-x>
                </button>
                <div class="recommend-container">
                  <div class="recommend-item" v-for="(item, index) in this.selectProArray" :key="index">
                    <div class="profile-area">
                      <div class="thumb-area">
                        <dd class="thumb" v-if="item.fileName === ''">
                          <img :src="require('../img/main/pro_defualt-img.png')">
                        </dd>
                        <dd class="thumb" v-else>
                            <img :src="imgUrl + '/' + item.fileName">
                        </dd>
                      </div>
                      <div class="kind-area">
                        <h3 class="tit">업종: <span>{{ item.proTypeNm }}</span></h3>
                        <p class="default-color">{{ item.proNm }}</p>
                        <p class="default-color">{{ item.proTel }}</p>
                      </div>
                    </div>
                    <div class="bottom-area">
                      <p class="txt"><span class="default-color">주소: </span>{{ item.proAddr }} {{ item.proAddrDt }}</p>
                      <p class="txt"><span class="default-color">담당구역: </span>{{ item.region1 }} {{ item.region2 }}</p>
                      <p class="txt"><span class="default-color">홈페이지 주소: </span><a :href="item.proUrl" target="_blank">{{ item.proUrl }}</a></p>
                    </div>
                  </div>
                </div>
              </div>
<!--              <button type="button" @click="popupClose" class="default-btn close-btn">닫기</button>-->
            </div>
        </div>
    </div>
    <urban-footer></urban-footer>
  </div>
</template>
<script>
import UrbanHeader from '@/components/UrbanHeader'
import UrbanFooter from '@/components/UrbanFooter'
import { mapGetters } from 'vuex'
const body = document.getElementsByTagName('body')[0]
export default {
  name: 'ViewEstate',
  components: {
    'urban-header': UrbanHeader,
    'urban-footer': UrbanFooter
  },
  data () {
    return {
      detailKind: '',
      detilePrice: '',
      firstPriceEstate: '',
      detailAddress: '',
      itemNumber: '',
      descEstate: '',
      typeDeal: '',
      typeEstateCode: '',
      startDate: '',
      endDate: '',
      offeringAmount: '',
      offeringPrice: '',
      returnAmount: '',
      proRecommend: false,
      kindRecommend: false,
      asidePopup: false,
      userPopup: false,
      recommendPopup: false,
      detailListFirst: {screen: true, tit: '해당층/건물층', desc: ''},
      detailListSecond: {screen: true, tit: '입주가능일', desc: ''},
      detailListThird: {screen: true, tit: '방향', desc: ''},
      detailListFourth: {screen: true, tit: '냉·난방종류', desc: ''},
      detailListFifth: {screen: true, tit: '기타', desc: ''},
      detailListSixth: {screen: true, tit: '주차', desc: ''},
      detailListSeventh: {screen: true, tit: '준공년도', desc: ''},
      detailListEighth: {screen: true, tit: '엘리베이터', desc: ''},
      detailListNinth: {screen: true, tit: '전용면적(대지면적)', desc: ''},
      detailListTenth: {screen: true, tit: '계약면적(연면적)', desc: ''},
      eaEstate_c: '',
      caEstate_c: '',
      /* getTypeProlists: [
        {idTypePro: 1, nameTypePro: '공인중개사'}
      ], */
      viewOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      images: [],
      imgUrl: this.$store.state.common.urlpath,
      selectPro: '',
      favoriteFlag: false,
      proTypeArray: [],
      selectProArray: []
    }
  },
  created () {
    // console.log(this.$route.params.id)
    this.setInit()
    this.setProInit()
    this.$store.dispatch('apiAttachedFiles', {'Gubun': '01', 'idAtFile': this.$route.params.id, 'flag': 'SELECT'})
  },
  mounted () {
    // this.setFavorit()
  },
  watch: {
    AttachedFile () {
      // console.log('watch')
    },
    getTypeProlists () {
      // proTypeArray
      let tmpType = []
      for (var i = 0; i < this.getTypeProlists.length; i++) {
        // console.log('idx = ' + tmpType.indexOf(this.getTypeProlists[i].proType))
        if (tmpType.indexOf(this.getTypeProlists[i].proType) === -1) {
          tmpType.push(this.getTypeProlists[i].proType)
          const obj = {
            proType: this.getTypeProlists[i].proType,
            proTypeNm: this.getTypeProlists[i].proTypeNm
          }
          this.proTypeArray.push(obj)
        }
      }
    }
  },
  methods: {
    setInit: function () {
      this.$store.dispatch('apiViewEstateById', {'idEstate': this.$route.params.id}).then(() => {
        // console.log(this.viewEstate)
        this.detailKind = this.viewEstate.CodeNm
        this.detilePrice = this.viewEstate.price
        this.firstPriceEstate = this.viewEstate.firstPriceEstate
        this.detailAddress = this.viewEstate.Addr
        this.itemNumber = this.viewEstate.idEstate
        this.detailListFirst.desc = this.viewEstate.floorEstate
        this.detailListSecond.desc = this.viewEstate.dateMoveIn
        this.detailListThird.desc = this.viewEstate.directionEstate
        this.detailListFourth.desc = this.viewEstate.typeCH
        this.detailListFifth.desc = this.viewEstate.etc
        this.detailListSixth.desc = this.viewEstate.parking
        this.detailListSeventh.desc = this.viewEstate.cdateEstate
        this.detailListEighth.desc = this.viewEstate.flagElevator
        this.detailListNinth.desc = this.viewEstate.eaEstate
        this.detailListTenth.desc = this.viewEstate.caEstate
        this.descEstate = this.viewEstate.descEstate
        this.lati = this.viewEstate.latiEstate
        this.longi = this.viewEstate.longiEstate
        this.typeDeal = this.viewEstate.typeDeal
        this.typeEstateCode = this.viewEstate.typeEstate
        this.startDate = this.viewEstate.startDate ? Number(this.viewEstate.startDate.replace(/[^0-9.]/g, '')) : ''
        this.endDate = this.viewEstate.endDate ? Number(this.viewEstate.endDate.replace(/[^0-9.]/g, '')) : ''
        this.offeringAmount = this.viewEstate.offeringAmount
        this.offeringPrice = this.viewEstate.offeringPrice
        this.returnAmount = this.viewEstate.returnAmount
        this.eaEstate()
        this.caEstate()
        if (window.kakao && window.kakao.maps) {
          this.initMap()
        } else {
          const script = document.createElement('script')
          script.onload = () => window.kakao.maps.load(this.initMap)
          // script.src = '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=ebc6dd7b4530f95243b07738554411d3'
          script.src = '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=2cc975adfb1b149255c44f49d88a036b'
          document.head.appendChild(script)
        }
      })
    },
    transferPrice (price) {
      const newPrice = parseInt(price.slice(0, -1).split(',').join(''))
      if (newPrice / 10000 >= 10000) {
        const newData = newPrice / 10000
        return `${newData.toString().replace(/[^0-9]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`
      }
      return `${newPrice.toString().replace(/[^0-9]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`
    },
    setProInit () {
      this.$store.dispatch('apiViewEstateProInfo', {'idEstate': this.$route.params.id}).then(() => {
        // console.log('getTypeProlists = ' + JSON.stringify(this.getTypeProlists))
        this.setFavorit()
      })
    },
    setFavorit () {
      if (sessionStorage.getItem('token') !== null) {
        this.$store.dispatch('apiCheckFavorite', {'estateId': this.$route.params.id}).then(() => {
          if (this.favoriteCheck.result === 'success') {
            // console.log('check: ' + this.favoriteCheck.check)
            this.favoriteFlag = this.favoriteCheck.check
          } else {
            alert('관심 매물 등록에 실패하였습니다.')
          }
        })
      }
    },
    favoriteToggle () {
      if (sessionStorage.getItem('token') === null) {
        const loginConfirm = confirm('로그인이 필요한 서비스 입니다.\n로그인으로 이동하겠습니까?')
        if (loginConfirm === true) {
          this.$router.replace('/Login')
        } else {
          return false
        }
      } else {
        let flag = 'I'
        let strMessage = '관심 매물로 등록 하시겠습니까?'
        if (this.favoriteFlag === true) {
          flag = 'D'
          strMessage = '관심 매물을 해제 하시겠습니까?'
        }
        const toggleConfirm = confirm(strMessage)
        if (toggleConfirm === true) {
          const params = {
            'flag': flag,
            'estateId': this.$route.params.id
          }
          this.$store.dispatch('apiTranMyFavorite', params).then(() => {
            if (this.favoriteTran.result === 'success') {
              this.favoriteFlag = !this.favoriteFlag
              this.$store.dispatch('apiMyFavorite')
            } else {
              alert('처리 도중 문제가 발생하였습니다.')
            }
          })
        } else {
          return false
        }
      }
    },
    prevPage () {
      this.$router.go(-1)
    },
    directContact () {
      body.classList.add('overflow')
      this.userPopup = true
      this.asidePopup = true
    },
    recommendOpen () {
      if (this.getTypeProlists.length === 0) {
        alert('이 매물의 지역은 전문가가 등록되어 있지 않습니다.')
      } else {
        body.classList.add('overflow')
        this.recommendPopup = true
        this.asidePopup = true
        this.proRecommend = true
      }
    },
    kindOpen (item, index) {
      this.selectProArray = []
      this.selectPro = item
      for (var i = 0; i < this.getTypeProlists.length; i++) {
        if (this.selectPro.proType === this.getTypeProlists[i].proType) {
          this.selectProArray.push(this.getTypeProlists[i])
        }
      }
      this.kindRecommend = true
      this.proRecommend = false
    },
    popupClose () {
      body.classList.remove('overflow')
      this.userPopup = false
      this.recommendPopup = false
      this.asidePopup = false
      this.kindRecommend = false
    },
    initMap () {
      // console.log(this.lati + '...' + this.longi)
      const container = document.getElementById('map')
      let options = {
        center: new window.kakao.maps.LatLng(this.lati, this.longi),
        level: 3
      }
      const map = new window.kakao.maps.Map(container, options)
      const zoomControl = new window.kakao.maps.ZoomControl()
      map.addControl(zoomControl, window.kakao.maps.ControlPosition.RIGHT)
      let markerPosition = new window.kakao.maps.LatLng(this.lati, this.longi) // 마커 위치
      let marker = new window.kakao.maps.Marker({
        position: markerPosition
      })
      marker.setMap(map)
    },
    eaEstate () {
      const num = this.detailListNinth.desc.toString().replace(/[^0-9.]/g, '')
      this.eaEstate_c = (num / 3.3058).toFixed(2)
      console.log(this.eaEstate_c)
    },
    caEstate () {
      const num = this.detailListTenth.desc.toString().replace(/[^0-9.]/g, '')
      this.caEstate_c = (num / 3.3058).toFixed(2)
    }
  },
  computed: {
    ...mapGetters({
      viewEstate: 'getViewEstate',
      AttachedFile: 'getAttachedFile',
      getTypeProlists: 'getViewEstatePro',
      favoriteTran: 'getMyFavoriteTran',
      favoriteCheck: 'getMyCheckFavorite'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ViewEstate.vue